import * as React from 'react';
import { useSelector } from 'react-redux';
import { BuilderInfo } from '../../components/BuilderInfo';
import { selectBuilderInfo } from '../../selectors/newbuilding';

export const BuilderInfoContainer: React.FC = () => {
  const builder = useSelector(selectBuilderInfo);

  if (!builder) {
    return null;
  }

  return (
    <BuilderInfo name={builder.name} logoUrl={builder.logoUrl} stats={builder.buildingsStatusInfo} url={builder.url} />
  );
};
